import {FormattedMessage, useIntl} from 'react-intl'

export function InspectionConditions() {
  const intl = useIntl()

  return (
    <div className='mb-2'>
      <div className='form-check-label d-flex flex-column align-items-start m-0'>
        <p className='text-muted fs-6 m-0 mb-1'>
          <FormattedMessage id='COMPONENTS.InspectionConditions.BASIC' />
        </p>
        <p
          className='text-muted fs-6 m-0'
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage({id: 'COMPONENTS.InspectionConditions.CHECK_BEFORE'}),
          }}
        ></p>
        <p
          className='text-muted fs-6 m-0 mb-2'
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage({id: 'COMPONENTS.InspectionConditions.CHECK_AFTER'}),
          }}
        ></p>
        <p className='text-muted fs-6 m-0 mb-1'>
          <FormattedMessage id='COMPONENTS.InspectionConditions.ADD' />
        </p>
        <p
          className='text-muted fs-6 m-0'
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage({id: 'COMPONENTS.InspectionConditions.CHECK_GOODS'}),
          }}
        ></p>{' '}
        <p
          className='text-muted fs-6 m-0'
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage({id: 'COMPONENTS.InspectionConditions.CHECK_FUNCTION'}),
          }}
        ></p>{' '}
        <p
          className='text-muted fs-6 m-0'
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage({id: 'COMPONENTS.InspectionConditions.ADD_WEIGHT'}),
          }}
        ></p>
      </div>
    </div>
  )
}
